const TokenKey = 'Answer-Api-Token'

export function getToken(type = 'local') {
    if (type === 'local') {
        return localStorage.getItem(TokenKey) || ''
    } else if (type === 'session') {
        return sessionStorage.getItem(TokenKey) || ''
    }
}

export function setToken(token, type = 'local') {
    if (type === 'local') {
        return localStorage.setItem(TokenKey, token)
    } else if (type === 'session') {
        return sessionStorage.setItem(TokenKey, token)
    }
}

export function removeToken(type = 'local') {
    if (type === 'local') {
        return localStorage.removeItem(TokenKey)
    } else if (type === 'session') {
        return sessionStorage.removeItem(TokenKey)
    }
}